export default __webpack_public_path__ + "static/media/IEA.54c78dd0.png";